export default "__VITE_ASSET__w97lOg$3__"